import { createRouter, createWebHistory } from 'vue-router'
import { pinia } from '@/stores'
import { useRegistrationStore } from '@/stores/registration'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/layouts/Home'),
    },
    {
      path: '/:type(business|individual)',
      component: () => import('@/views/layouts/Main'),
      children: [
        {
          path: '',
          name: 'CreateAccount',
          component: () => import('@/views/steps/CreateAccount'),
        },
      ],
      beforeEnter: (to, from, next) => {
        useRegistrationStore(pinia).setRegistrationType(to.params.type)
        next()
      },
    },
    {
      path: '/verification/:token',
      name: 'VerificationComplete',
      component: () => import('@/views/steps/VerificationComplete'),
      props: true,
    },
    {
      path: '/unavailable',
      name: 'Unavailable',
      component: () => import('@/views/steps/Unavailable'),
    },
    {
      path: '/error',
      name: 'Error',
      component: () => import('@/views/layouts/Error'),
    },
    {
      path: '/:hash/complete',
      name: 'RegistrationCompleted',
      component: () => import('@/views/steps/RegistrationCompleted'),
    },
    {
      path: '/:hash',
      component: () => import('@/views/layouts/Main'),
      name: 'ContinueRegistration',
      children: [
        // Business
        {
          path: 'company',
          name: 'BusinessCompany',
          component: () => import('@/views/business/Company'),
        },
        {
          path: 'legal-address',
          name: 'LegalAddress',
          component: () => import('@/views/business/LegalAddress'),
        },
        {
          path: 'operating-address',
          name: 'BusinessOperatingAddress',
          component: () => import('@/views/business/OperatingAddress'),
        },
        {
          path: 'director',
          name: 'BusinessDirector',
          component: () => import('@/views/business/Director'),
        },
        {
          path: 'ubo',
          name: 'BusinessUBO',
          component: () => import('@/views/business/UBO'),
        },
        {
          path: 'partners',
          name: 'BusinessPartners',
          component: () => import('@/views/business/Partners'),
        },
        {
          path: 'kyc',
          name: 'BusinessKYC',
          component: () => import('@/views/business/KYC'),
        },

        // Individual
        {
          path: 'user-profile',
          name: 'IndividualContactInfo',
          component: () => import('@/views/individual/ContactInfo'),
        },

        // Many types
        {
          path: 'verification/:device?',
          name: 'Verification',
          component: () => import('@/views/steps/Verification'),
        },
        {
          path: 'finish',
          name: 'Finish',
          component: () => {
            return useRegistrationStore(pinia).type === 'business'
              ? import('@/views/business/Finish')
              : import('@/views/individual/Finish.vue')
          },
        },
      ],
      beforeEnter: (to, from, next) => {
        useRegistrationStore(pinia)
          .getRegistration(to.params.hash)
          .then(() => {
            next()
          })
          .catch((error) => {
            if (
              error instanceof Error &&
              error.response &&
              error.response.status === 403
            ) {
              next({
                name: 'RegistrationCompleted',
                params: { hash: to.params.hash },
              })
            } else {
              next({ name: 'Error' })
            }
          })
      },
    },
  ],
})

function getRouteRegion(to, from) {
  return (
    (to.query && to.query.r) ||
    (from.query && from.query.r) ||
    new URLSearchParams(window.location.search).get('r')
  )
}

router.beforeEach((to, from, next) => {
  const r = getRouteRegion(to, from)

  if (r && to.query.r !== r) {
    return next({ ...to, query: { ...to.query, r } })
  }

  next()
})

export default router
